/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_PT_BR: Record<string, string> = {
    ariaAnnounceChart: 'gráfico, ${seriesCount}[number] séries',
    ariaAnnounceFlowProportionLink: 'link ${index} de ${count}, de ${from} para ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'nó ${index} de ${count}, ${description}',
    ariaAnnounceGaugeChart: 'gráfico de medidor, ${caption}',
    ariaAnnounceHierarchyChart: 'gráfico de hierarquia, ${caption}',
    ariaAnnounceHierarchyDatum: 'nível ${level}[number], ${count}[number] filhos, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Pressione Espaço ou Enter para alternar a visibilidade',
    ariaLabelAddHorizontalLine: 'Adicionar Linha Horizontal',
    ariaLabelAnnotationOptionsToolbar: 'Opções de Anotação',
    ariaLabelAnnotationSettingsDialog: 'Configurações de Anotação',
    ariaLabelColorPicker: 'Seletor de cores',
    ariaLabelFinancialCharts: 'Gráficos financeiros',
    ariaLabelLegend: 'Legenda',
    ariaLabelLegendItem: '${label}, Item da legenda ${index}[number] de ${count}[number]',
    ariaLabelLegendItemUnknown: 'Item desconhecido da legenda',
    ariaLabelLegendPageNext: 'Próxima Página da Legenda',
    ariaLabelLegendPagePrevious: 'Página Anterior da Legenda',
    ariaLabelLegendPagination: 'Paginação da Legenda',
    ariaLabelNavigator: 'Navegador',
    ariaLabelNavigatorMaximum: 'Máximo',
    ariaLabelNavigatorMinimum: 'Mínimo',
    ariaLabelNavigatorRange: 'Intervalo',
    ariaLabelRangesToolbar: 'Faixas',
    ariaLabelSettingsTabBar: 'Configurações',
    ariaLabelZoomToolbar: 'Zoom',
    ariaValuePanRange: '${min}[percent0to2dp] a ${max}[percent0to2dp]',
    contextMenuDownload: 'Baixar',
    contextMenuPanToCursor: 'Mover para aqui',
    contextMenuToggleOtherSeries: 'Alternar Outras Séries',
    contextMenuToggleSeriesVisibility: 'Alternar Visibilidade',
    contextMenuZoomToCursor: 'Dar zoom aqui',
    dialogHeaderChannel: 'Canal',
    dialogHeaderDatePriceRange: 'Data e Preço',
    dialogHeaderDateRange: 'Intervalo de Datas',
    dialogHeaderFibonacciRange: 'Retração de Fib',
    dialogHeaderLine: 'Linha',
    dialogHeaderPriceRange: 'Faixa de Preço',
    dialogHeaderText: 'Texto',
    dialogInputAlign: 'Alinhar',
    dialogInputColorPicker: 'Cor',
    dialogInputColorPickerAltText: 'Cor do Texto',
    dialogInputExtendAbove: 'Estender acima',
    dialogInputExtendBelow: 'Estender abaixo',
    dialogInputExtendChannelEnd: 'Estender final do canal',
    dialogInputExtendChannelStart: 'Estender início do canal',
    dialogInputExtendLeft: 'Estender à esquerda',
    dialogInputExtendLineEnd: 'Estender fim da linha',
    dialogInputExtendLineStart: 'Estender início da linha',
    dialogInputExtendRight: 'Estender à direita',
    dialogInputFibonacciBands: 'Bandas',
    dialogInputFibonacciBandsAltText: 'Bandas de Fibonacci',
    dialogInputFillColorPicker: 'Preencher',
    dialogInputFillColorPickerAltText: 'Cor de Preenchimento',
    dialogInputFontSize: 'Tamanho',
    dialogInputFontSizeAltText: 'Tamanho da Fonte',
    dialogInputLineStyle: 'Tracejado',
    dialogInputPosition: 'Posição',
    dialogInputReverse: 'Inverter',
    dialogInputShowFill: 'Exibir Preenchimento',
    dialogInputStrokeWidth: 'Peso',
    dialogInputStrokeWidthAltText: 'Peso da Linha',
    iconAltTextAlignCenter: 'Centralizar',
    iconAltTextAlignLeft: 'Esquerda',
    iconAltTextAlignRight: 'Direita',
    iconAltTextClose: 'Fechar',
    iconAltTextLineStyleDashed: 'Traço longo',
    iconAltTextLineStyleDotted: 'Traço Curto',
    iconAltTextLineStyleSolid: 'Sólido',
    iconAltTextPositionBottom: 'Inferior',
    iconAltTextPositionCenter: 'Centro',
    iconAltTextPositionTop: 'Topo',
    inputTextareaPlaceholder: 'Adicionar Texto',
    measurerDateRangeBars: '${value}[number] barras',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: '"Vol ${value}"',
    overlayLoadingData: 'Carregando dados...',
    overlayNoData: 'Sem dados para exibir',
    overlayNoVisibleSeries: 'Nenhuma série visível',
    overlayUnsupportedBrowser: 'Versão do navegador incompatível. Por favor, atualize seu navegador.',
    seriesHistogramTooltipCount: '${yName} (contagem)',
    seriesHistogramTooltipFrequency: 'Frequência',
    seriesHistogramTooltipMean: '${yName} (média)',
    seriesHistogramTooltipSum: '${yName} (soma)',
    toolbarAnnotationsArrow: 'Seta',
    toolbarAnnotationsArrowDown: 'Seta para Baixo',
    toolbarAnnotationsArrowUp: 'Seta para cima',
    toolbarAnnotationsCallout: 'Anotação',
    toolbarAnnotationsClearAll: 'Limpar Tudo',
    toolbarAnnotationsComment: 'Comentar',
    toolbarAnnotationsDatePriceRange: 'Data e Preço',
    toolbarAnnotationsDateRange: 'Intervalo de Datas',
    toolbarAnnotationsDelete: 'Excluir',
    toolbarAnnotationsDisjointChannel: 'Canal Independente',
    toolbarAnnotationsDragHandle: 'Arrastar Barra de Ferramentas',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Retração de Fibonacci',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Tendência Baseada em Fib',
    toolbarAnnotationsFillColor: 'Cor de Preenchimento',
    toolbarAnnotationsHorizontalLine: 'Linha Horizontal',
    toolbarAnnotationsLineAnnotations: 'Linhas de Tendência',
    toolbarAnnotationsLineColor: 'Cor da Linha',
    toolbarAnnotationsLineStrokeWidth: 'Espessura do Traço da Linha',
    toolbarAnnotationsLineStyle: 'Estilo de Linha',
    toolbarAnnotationsLock: 'Bloquear',
    toolbarAnnotationsMeasurerAnnotations: 'Medidores',
    toolbarAnnotationsNote: 'Nota',
    toolbarAnnotationsParallelChannel: 'Canal Paralelo',
    toolbarAnnotationsPriceRange: 'Faixa de Preço',
    toolbarAnnotationsQuickDatePriceRange: 'Medir',
    toolbarAnnotationsSettings: 'Configurações',
    toolbarAnnotationsShapeAnnotations: 'Setas',
    toolbarAnnotationsText: 'Texto',
    toolbarAnnotationsTextAnnotations: 'Anotações de Texto',
    toolbarAnnotationsTextColor: 'Cor do Texto',
    toolbarAnnotationsTextSize: 'Tamanho do Texto',
    toolbarAnnotationsTrendLine: 'Linha de Tendência',
    toolbarAnnotationsUnlock: 'Desbloquear',
    toolbarAnnotationsVerticalLine: 'Linha Vertical',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 mês',
    toolbarRange1Year: '1A',
    toolbarRange1YearAria: '1 ano',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 meses',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 meses',
    toolbarRangeAll: 'Todos',
    toolbarRangeAllAria: 'Tudo',
    toolbarRangeYearToDate: 'YTD',
    toolbarRangeYearToDateAria: 'Ano até a data',
    toolbarSeriesTypeCandles: 'Velas',
    toolbarSeriesTypeDropdown: 'Tipo de Gráfico',
    toolbarSeriesTypeHighLow: 'Alta Baixa',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Velas Vazadas',
    toolbarSeriesTypeLine: 'Linha',
    toolbarSeriesTypeLineWithMarkers: 'Linha com Marcadores',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Linha de Passos',
    toolbarZoomPanEnd: 'Panorar para o final',
    toolbarZoomPanLeft: 'Mover para a esquerda',
    toolbarZoomPanRight: 'Mover para a direita',
    toolbarZoomPanStart: 'Mover para o início',
    toolbarZoomReset: 'Redefinir o zoom',
    toolbarZoomZoomIn: 'Aproximar',
    toolbarZoomZoomOut: 'Diminuir zoom',
    tooltipPaginationStatus: '${index}[number] de ${count}[number]',
};
